// extracted by mini-css-extract-plugin
var _1 = "PasswordInput-modulebutton__fMqHZ";
export { _1 as "button" }
